import React from 'react';
import { VaultKeTheme } from '../../utils/theme';

const Blog: React.FC = () => {
  const styles: { [key: string]: React.CSSProperties } = {
    page: {
      minHeight: '100vh',
      backgroundColor: VaultKeTheme.colors.background,
      color: VaultKeTheme.colors.text,
    },
    main: {
      paddingTop: '80px',
      paddingBottom: VaultKeTheme.spacing.xxl,
    },
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: `0 ${VaultKeTheme.spacing.xl}`,
    },
    header: {
      textAlign: 'center',
      marginBottom: VaultKeTheme.spacing.xxl,
    },
    title: {
      ...VaultKeTheme.typography.h1,
      color: VaultKeTheme.colors.text,
      marginBottom: VaultKeTheme.spacing.lg,
    },
    subtitle: {
      ...VaultKeTheme.typography.body1,
      color: VaultKeTheme.colors.textSecondary,
      maxWidth: '600px',
      margin: '0 auto',
    },
    posts: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
      gap: VaultKeTheme.spacing.xl,
    },
    post: {
      ...VaultKeTheme.components.card,
      cursor: 'pointer',
      transition: 'transform 0.3s ease',
    },
    postImage: {
      width: '100%',
      height: '200px',
      background: `linear-gradient(135deg, ${VaultKeTheme.colors.surface} 0%, ${VaultKeTheme.colors.surfaceVariant} 100%)`,
      borderRadius: `${VaultKeTheme.borderRadius.lg} ${VaultKeTheme.borderRadius.lg} 0 0`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '3rem',
    },
    postContent: {
      padding: VaultKeTheme.spacing.lg,
    },
    postTitle: {
      ...VaultKeTheme.typography.h4,
      color: VaultKeTheme.colors.text,
      marginBottom: VaultKeTheme.spacing.sm,
    },
    postExcerpt: {
      ...VaultKeTheme.typography.body2,
      color: VaultKeTheme.colors.textSecondary,
      marginBottom: VaultKeTheme.spacing.md,
      lineHeight: '1.6',
    },
    postMeta: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    postDate: {
      ...VaultKeTheme.typography.caption,
      color: VaultKeTheme.colors.textTertiary,
    },
    postCategory: {
      ...VaultKeTheme.typography.caption,
      color: VaultKeTheme.colors.primary,
      fontWeight: '600',
    },
  };

  const posts = [
    {
      title: 'The Future of Community Savings in Africa',
      excerpt: 'Explore how digital transformation is revolutionizing traditional savings groups and what it means for the future of community finance.',
      date: 'December 15, 2024',
      category: 'Trends',
      icon: '🌍',
    },
    {
      title: 'Building Financial Literacy in Chamas',
      excerpt: 'Learn how modern chamas can incorporate financial education to empower members and improve long-term financial health.',
      date: 'December 10, 2024',
      category: 'Education',
      icon: '📚',
    },
    {
      title: 'Security Best Practices for Digital Savings',
      excerpt: 'Essential security measures every chama should implement to protect member funds and maintain trust in the digital age.',
      date: 'December 5, 2024',
      category: 'Security',
      icon: '🔒',
    },
    {
      title: 'From Traditional to Digital: A Chama Success Story',
      excerpt: 'How one Nairobi-based chama transformed their operations with VaultKe and achieved unprecedented growth.',
      date: 'November 28, 2024',
      category: 'Case Study',
      icon: '📈',
    },
    {
      title: 'Understanding Loan Management in Modern Chamas',
      excerpt: 'A comprehensive guide to implementing fair and transparent loan systems that benefit all chama members.',
      date: 'November 20, 2024',
      category: 'Finance',
      icon: '💰',
    },
    {
      title: 'The Role of Technology in Community Building',
      excerpt: 'How digital tools can strengthen community bonds while providing modern financial management capabilities.',
      date: 'November 15, 2024',
      category: 'Community',
      icon: '🤝',
    },
  ];

  return (
    <div style={styles.page}>
      <main style={styles.main}>
        <div style={styles.container}>
          <div style={styles.header}>
            <h1 style={styles.title}>VaultKe Blog</h1>
            <p style={styles.subtitle}>
              Insights, trends, and stories from the world of community finance and digital transformation.
            </p>
          </div>

          <div style={styles.posts}>
            {posts.map((post, index) => (
              <div key={index} style={styles.post}>
                <div style={styles.postImage}>
                  {post.icon}
                </div>
                <div style={styles.postContent}>
                  <h3 style={styles.postTitle}>{post.title}</h3>
                  <p style={styles.postExcerpt}>{post.excerpt}</p>
                  <div style={styles.postMeta}>
                    <span style={styles.postDate}>{post.date}</span>
                    <span style={styles.postCategory}>{post.category}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
};

export default Blog;